// extracted by mini-css-extract-plugin
module.exports = {"image":"Instructors_image__Lp9hq"};